export enum NotificationStatus {
  New = 'new',
  Read = 'read',
}

export type NotificationType = {
  correlationId: string;
  notificationId: string;
  message: string;
  status: NotificationStatus;
  timeStamp: Date;
  _data: NotificationData;
};

export type SignalRNotificationType = {
  correlationId: string;
  notificationId: string;
  message: string;
  status: 0 | 1;
  timeStamp: Date;
  _data: NotificationData;
};

export type NotificationData = any;

export type HttpErrorData = {
  isSuccesful: boolean;
  statusCode: number;
  errorMessage: string;
  fieldErrors?: object;
};

export type HttpErrorResponse = {
  data: HttpErrorData;
  status: number;
};
